import Controller from "@ember/controller"
import { alias } from "@ember/object/computed"
import { inject as service } from "@ember/service"

export default class SignUpController extends Controller {
  @service router

  // Computed properties
  @alias("router.currentRouteName") currentPath
}
